import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
import {DriverVehicleReservationStatusEnum} from '@/services/api-clients';

export function driverVehicleReservationStatusNameFilter(value: DriverVehicleReservationStatusEnum): string {
  switch (value) {
    case DriverVehicleReservationStatusEnum.Waiting: return i18n.t(LF.Waiting) as string;
    case DriverVehicleReservationStatusEnum.Approved: return i18n.t(LF.Approved) as string;
    case DriverVehicleReservationStatusEnum.Cancelled: return i18n.t(LF.Canceled) as string;
  }
}
